const LoadingActionTypes = {
    LOADING: "buscar/loading",
}

export default LoadingActionTypes;